import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import config from '../../config';
import { FormattedMessage, injectIntl } from '../../utils/reactIntl';
import {
  Login,
  Page,
  NamedRedirect,
  ForgotPassword,
  ResetPasswordForm,
} from '../../components';
import {
  changeSuccessPass,
  forgotPassword,
  loginRequest,
} from '../../actions/auth';
import { AuthService } from '../../services/index';
import { fetchToken } from '../../utils/firebase.js';
import { aesEncrypted } from '../../utils/aesEncrypt';
import avtausLogo from '../../assets/svg/avatus_logo.svg';

import './auth.scss';
import BrandLockup from '../../components/BrandLockup';
import emblem from '../../assets/brand/logo.svg';
import './loginBrand.scss';
interface Props {
  isAuth: boolean,
  scrollingDisabled: boolean,
  submitlogin: any,
  intl: any,
  tab: any,
  loginError: any,
  forgotpassSucess: any,
  forgotpassError: any,
  forgotPass: any,
}

const AuthenticationPageComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    isAuth,
    scrollingDisabled,
    tab,
    submitlogin,
    loginError,
    forgotPass,
    forgotpassSucess,
    forgotpassError,
  } = props;
  const location = useLocation();
  const [tokenFound, setTokenFound] = useState<null | string>(null);

  const [resetPassword, setResetPassword] = useState(false);

  useEffect(() => {
    if (typeof (tokenFound) !== 'string') {
      fetchToken(setTokenFound);
    }
  }, [setTokenFound, tokenFound]);

  const submitLogin = (values: any) => {
    if (values.remember) {
      Cookies.set('email_authInfo', values.email);
      Cookies.set('password_authInfo', values.password);
    } else {
      Cookies.remove('email_authInfo');
      Cookies.remove('password_authInfo');
    }
    const data = aesEncrypted(JSON.stringify({
      email: values.email,
      password: values.password,
      deviceId: `${values.email}_${(new Date()).getUTCDate()}`, // Unique Identifier Token
      deviceToken: tokenFound === null ? '' : tokenFound, // Firebase token
    }));
    submitlogin(data);
  };
  const handleForgotPassword = (values: any) => {
    forgotPass(values);
  };

  // const isLogin = tab === 'login';
  // const [state, setState] = useState({
  //   tosModalOpen: false,
  //   authError: authError
  //     ? JSON.parse(authError.replace('j:', ''))
  //     : null,
  //   authInfo: authInfo
  //     ? JSON.parse(authInfo.replace('j:', ''))
  //     : null,
  // });

  // const locationFrom = location.state && location.state.from ? location.state.from : null;
  // const authinfoFrom = state.authInfo && state.authInfo.from
  //   ? state.authInfo.from
  //   : null;
  // const from = locationFrom || (authinfoFrom || null);

  // Already authenticated, redirect away from auth page

  if (isAuth) {
    AuthService.authRequest();
    return <NamedRedirect name="Dashboard" />;
    // return <Redirect to={from} />;
  }
  // if (isAuth) {
  //   return <NamedRedirect name="Dashboard" />;
  // }

  const handleResetPassword = (data: any, resetToken: any) => {
    const values = aesEncrypted(JSON.stringify({
      resetToken: resetToken.resetToken,
      password: data.password,
    }));
    AuthService.resetPassword({
      data: values,
    }).then(() => {
      setResetPassword(true);
    });
  };

  const loginErrorMessage = (
    <div className="error">
      <FormattedMessage id="AuthenticationPage.loginFailed" />
    </div>
  );
  const errorMessage = (error: any, message: any) => (error ? message : null);
  const loginOrSignupError = errorMessage('', loginErrorMessage);

  // const authenticationForms = (isLogin
  //   ? (
  //     <div className="content">
  //       {loginOrSignupError}
  //       <Login
  //         handleSubmit={submitLogin}
  //         loginError={loginError}
  //         changeSuccessPass={changeSuccessPass}
  //       />
  //     </div>
  //   ) : (
  //     <div className="content">
  //       <ForgotPassword
  //         handleSubmit={handleForgotPassword}
  //         forgotpassSucess={forgotpassSucess}
  //         forgotpassError={forgotpassError}
  //       />
  //     </div>
  //   )
  // );

  const authenticationForms = (
    <>
      {
        tab === 'login'
        && (
          <div className="content">
            {loginOrSignupError}
            <Login
              handleSubmit={submitLogin}
              loginError={loginError}
              changeSuccessPass={changeSuccessPass}
            />
          </div>
        )
      }
      {
        tab === 'forgotpassword'
        && (
          <div className="content">
            <ForgotPassword
              handleSubmit={handleForgotPassword}
              forgotpassSucess={forgotpassSucess}
              forgotpassError={forgotpassError}
            />
          </div>
        )
      }
      {
        tab === 'resetPassword'
        && (
          <div className="content">
            <ResetPasswordForm
              handleResetPassword={handleResetPassword}
              resetPassword={resetPassword}
            />
          </div>
        )
      }
    </>

  );

  const formContent = authenticationForms;

  const { siteTitle } = config;

  const schemaTitle = () => {
    if (tab === 'login') {
      return intl.formatMessage(
        { id: 'AuthenticationPage.schemaTitleLogin' },
        { siteTitle },
      );
    }
    if (tab === 'forgotpassword') {
      return intl.formatMessage(
        { id: 'AuthenticationPage.ForgotPassword' },
        { siteTitle },
      );
    }
    if (tab === 'resetPassword') {
      return intl.formatMessage(
        { id: 'AuthenticationPage.ResetPassword' },
        { siteTitle },
      );
    }
    return null;
  };

  return (
    <Page
      title={schemaTitle()}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      {tab === 'login' ? <div className="avatus-login">
        <header className="login-header"><BrandLockup /><span className="header-label">ADMIN WORKSPACE</span></header>
        <main className="login-main"><section className="identity" aria-label="AVATUS admin workspace">
          <div className="orbital orbital-one" /><div className="orbital orbital-two" />
          <div className="hero"><div className="hero-logo"><img src={emblem} alt="" /></div><div className="eyebrow">AVATUS ADMIN</div><h1>YOUR PLATFORM.<br />IN FOCUS.</h1><p>One place to manage your AVATUS world.</p><div className="spectrum" /></div>
          <div className="identity-foot"><span>THE AVATUS WORKSPACE</span><span className="tiny-mark">01 / ACCESS</span></div>
        </section><section className="signin"><div className="form-wrap"><div className="section-label"><span />ADMIN ACCESS</div>{formContent}<p className="access-note">Authorized administrators only.</p></div></section></main>
        <footer className="login-footer"><span>AVATUS</span><span>Admin workspace</span></footer>
      </div> : <div className="auth_row">
        <div className="column">
          <img src={avtausLogo} alt="avatus logo" />
        </div>
        <div className="column">
            {formContent}
        </div>
      </div>}
    </Page>
  );
};

const mapStateToProps = (state: any) => {
  const { auth } = state;
  return {
    isAuth: auth.isAuthenticated,
    loginError: auth.loginError,
    forgotpassSucess: auth.forgotpassSucess,
    forgotpassError: auth.forgotpassError,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  submitlogin: (data: any) => dispatch(loginRequest(data)),
  forgotPass: (data: any) => dispatch(forgotPassword(data)),
  changeSuccessPass: () => dispatch(changeSuccessPass()),
});

const AuthenticationPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(AuthenticationPageComponent);

export default AuthenticationPage;
